/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { Grid, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import CarouselComponent from "../../shared/components/reusableComp/CarouselComponent";
import SidebarCarousel from "../../shared/components/reusableComp/SidebarCarousel";
import { useEffect, useRef, useState } from "react";
import { getHomepageDetails } from "./homepageApiCalls";
import {
  DESKTOP_VIEW_WIDTH,
  TAB_VIEW_WIDTH,
} from "../../shared/constants/constants";
import MultipleSlidesCarousel from "../../shared/components/reusableComp/MultipleSlidesCarousel";
import QuickLinksComp from "../../shared/components/reusableComp/QuickLinksComp";

const carouselStyle = (matches, matchesTab) => css`
  // height: ${(matches && "85vh") || "80vh"};
  background: #121212;
  scroll-margin-top: ${(matches && "80px") || (matchesTab && "69px") || "56px"};
  height: 75vw;
  min-height: ${matches ? "70vh" : "65vh"};
  max-height: 85vh;
`;

const cardCarouselStyle = (matches) => css`
  background: #121212;
  height: 45vw;
  min-height: ${matches ? "50vh" : "70vw"};
  max-height: 90vh;
`;

const quickContainerCss = (matches) => css`
  display: flex;
  justify-content: space-between;
  padding-top: 20px;
  margin-bottom: 40px;
  display: flex;
  justify-content: ${matches ? "center" : "space-evenly"};
  align-items: center;
`;

const useStyles = makeStyles({
  quickLinks: {
    width: "35.417%",
    height: "26.042vw",
    backgroundColor: "#9b9b9b",
    position: "relative",
  },
});
const HomePage = () => {
  const [carouselData, setCarouselData] = useState([]);
  const [sideCarouselData, setSideCarouselData] = useState([]);
  const [industryCardData, setIndustryCardData] = useState([]);
  const [quickLinksData, setQuickLinksData] = useState([]);
  const matches = useMediaQuery(DESKTOP_VIEW_WIDTH);
  const matchesTab = useMediaQuery(TAB_VIEW_WIDTH);
  const styles = useStyles();
  const myRef = useRef();

  useEffect(() => {
    getHomepageDetails().then(({ data }) => {
      document.title = data?.data?.attributes?.title;
      data?.data?.attributes?.body?.map((item) => {
        switch (item.__component) {
          case "components.carousel":
            if (item.isHoverCarousel) setSideCarouselData([...item.slides]);
            else setCarouselData([...item.slides]);
            break;
          case "components.list":
            setQuickLinksData([...item.ctaList]);
            break;
          case "components.card-carousel":
            setIndustryCardData([...item.card]);
            break;
        }
      });
    });
  }, []);

  const handleScroll = () => {
    myRef.current.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <div className="App" style={{ zIndex: "-1", marginTop: "" }}>
      <Grid container style={{ background: "#121212" }}>
        {carouselData?.length > 0 && (
          <Grid item className={`${styles.carousel}`} xs={12}>
            <CarouselComponent
              carouselData={carouselData}
              handleScroll={handleScroll}
              autoplay={true}
            />
          </Grid>
        )}

        {sideCarouselData?.length > 0 && (
          <Grid
            ref={myRef}
            item
            css={() => carouselStyle(matches, matchesTab)}
            xs={12}
          >
            <SidebarCarousel sideCarouselData={sideCarouselData} />
          </Grid>
        )}
        {industryCardData?.length > 0 && (
          <Grid
            item
            p={matches ? 10 : 5}
            pr={matches && 10}
            pl={matches && 10}
            css={() => cardCarouselStyle(matches, matchesTab)}
            xs={12}
          >
            <MultipleSlidesCarousel industryCardData={industryCardData} />
          </Grid>
        )}

        {quickLinksData?.length >= 0 && (
          <Grid item css={() => quickContainerCss(matches)} xs={12}>
            <QuickLinksComp quickLinksData={quickLinksData} />
          </Grid>
        )}
      </Grid>
    </div>
  );
};

export default HomePage;
